module.exports = __webpack_public_path__ + "img/download.1862694b.svg";